/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserAccountQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetUserAccountQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, gender?: string | null, householdSize?: number | null, dwellingType?: string | null, formattedAddress?: string | null, addressLine1?: string | null, addressLine2?: string | null, postcode?: string | null, state?: string | null, phoneNumber?: string | null, isOver18?: boolean | null, isParticipatingInPrizeDraw?: boolean | null, lat?: number | null, lng?: number | null, city?: string | null, cityPlaceId?: string | null, isManualAddress?: boolean | null, placeId?: string | null, linkedCouncil?: { __typename?: 'Council', id: string, name: string } | null, contact: { __typename?: 'Contact', id: string, email?: string | null, firstName?: string | null, lastName?: string | null } } | null };

export type UpdateUserAccountMutationVariables = Types.Exact<{
  input: Types.UserInput;
}>;


export type UpdateUserAccountMutation = { __typename?: 'Mutation', updateCurrentUser?: { __typename?: 'User', id: string } | null };


export const GetUserAccountDocument = gql`
    query GetUserAccount($id: ID!) {
  user(id: $id) {
    id
    gender
    householdSize
    dwellingType
    formattedAddress
    addressLine1
    addressLine2
    linkedCouncil {
      id
      name
    }
    postcode
    state
    phoneNumber
    isOver18
    isParticipatingInPrizeDraw
    lat
    lng
    city
    cityPlaceId
    isManualAddress
    contact {
      id
      email
      firstName
      lastName
    }
    placeId
  }
}
    `;

/**
 * __useGetUserAccountQuery__
 *
 * To run a query within a React component, call `useGetUserAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserAccountQuery(baseOptions: Apollo.QueryHookOptions<GetUserAccountQuery, GetUserAccountQueryVariables> & ({ variables: GetUserAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAccountQuery, GetUserAccountQueryVariables>(GetUserAccountDocument, options);
      }
export function useGetUserAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAccountQuery, GetUserAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAccountQuery, GetUserAccountQueryVariables>(GetUserAccountDocument, options);
        }
export function useGetUserAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserAccountQuery, GetUserAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserAccountQuery, GetUserAccountQueryVariables>(GetUserAccountDocument, options);
        }
export type GetUserAccountQueryHookResult = ReturnType<typeof useGetUserAccountQuery>;
export type GetUserAccountLazyQueryHookResult = ReturnType<typeof useGetUserAccountLazyQuery>;
export type GetUserAccountSuspenseQueryHookResult = ReturnType<typeof useGetUserAccountSuspenseQuery>;
export type GetUserAccountQueryResult = Apollo.QueryResult<GetUserAccountQuery, GetUserAccountQueryVariables>;
export const UpdateUserAccountDocument = gql`
    mutation UpdateUserAccount($input: UserInput!) {
  updateCurrentUser(input: $input) {
    id
  }
}
    `;
export type UpdateUserAccountMutationFn = Apollo.MutationFunction<UpdateUserAccountMutation, UpdateUserAccountMutationVariables>;

/**
 * __useUpdateUserAccountMutation__
 *
 * To run a mutation, you first call `useUpdateUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAccountMutation, { data, loading, error }] = useUpdateUserAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAccountMutation, UpdateUserAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAccountMutation, UpdateUserAccountMutationVariables>(UpdateUserAccountDocument, options);
      }
export type UpdateUserAccountMutationHookResult = ReturnType<typeof useUpdateUserAccountMutation>;
export type UpdateUserAccountMutationResult = Apollo.MutationResult<UpdateUserAccountMutation>;
export type UpdateUserAccountMutationOptions = Apollo.BaseMutationOptions<UpdateUserAccountMutation, UpdateUserAccountMutationVariables>;